import * as core from '../../../../../../../core'

import { query } from './degree-and-value-of-change-table.query'

export const RESOURCE = {
  payload: {
    alias: 'degree.and.value.of.change.table',
    description: 'Table view of degree and value of change',
    name: 'Degree and Value of Change Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
